import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';

const CardSearch = ({ value, onChange, placeholder = 'Filter…', ariaLabel = 'Filter list' }) => {
    const [expanded, setExpanded] = useState(!!value);
    const inputRef = useRef(null);

    useEffect(() => {
        if (value && !expanded) setExpanded(true);
    }, [value, expanded]);

    const handleExpand = () => {
        setExpanded(true);
        // Focus on next tick so the input has mounted
        setTimeout(() => inputRef.current?.focus(), 0);
    };

    const handleClear = () => {
        onChange('');
        setExpanded(false);
    };

    const handleBlur = () => {
        if (!value) setExpanded(false);
    };

    const handleKey = (e) => {
        if (e.key === 'Escape') {
            e.preventDefault();
            handleClear();
        }
    };

    if (!expanded) {
        return (
            <button
                type="button"
                className="djpal-card-search collapsed"
                onClick={handleExpand}
                aria-label={ariaLabel}
                title={ariaLabel}
            >
                <SearchIcon className="djpal-card-search-glass" />
            </button>
        );
    }

    return (
        <div className="djpal-card-search expanded">
            <SearchIcon className="djpal-card-search-glass" />
            <input
                ref={inputRef}
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onBlur={handleBlur}
                onKeyDown={handleKey}
                placeholder={placeholder}
                aria-label={ariaLabel}
            />
            {value && (
                <button
                    type="button"
                    className="djpal-card-search-clear"
                    onClick={handleClear}
                    aria-label="Clear filter"
                    tabIndex={-1}
                >
                    ×
                </button>
            )}
        </div>
    );
};

export default CardSearch;
